module.exports = __webpack_public_path__ + "img/magento-version-switching.f9d48703.webp";